/**
 * German language package.
*/
export default {
    'profile': 'Profil',
    'changeLanguage': 'Sprache ändern',
    'password': 'PASSWORT',

    'inbox': 'Posteingang',
    'outbox': 'Postausgang',
    'storage': 'Lager',
    'storageLink': '▸ Lager',
    'articleTypes': 'Artikeltypen',
    'stock': 'Bestände',
    'deliveryArchive': 'Lieferarchiv',
    'salesReport': 'Verkaufsauswertung',
    'b2cOrders' : 'Bestellungen',

    'search': 'Suche...',
    'filterArticles': 'Artikel filtern',
    'filterTransactions': 'Lieferscheine filtern',
    'filter': 'Filter',
    'export': 'Export',

    'save': 'Speichern',
    'confirm': 'Bestätigen',
    'abort': 'Abbrechen',
    'saveDraft': 'Entwurf speichern',
    'sendTransaction': 'Lieferung abschicken',

    'addDeliveryOrder': 'Neuer Lieferschein',
    'addArticleType': 'Neuen Artikeltyp hinzufügen',
    'updateArticleType': 'Artikeltyp bearbeiten',
    'addStock': 'Neuer Bestand',
    'addStockCorrection': 'Bestandskorrektur',
    'showAllArticles': 'Alle Artikel',
    'showStockTransactions': 'Bestandstransaktionen',
    'showEmptyStocks': 'Leere Bestände',
    'showNonEmptyStocks': 'Nur Volle Bestände',
    'all_articleTypes': 'Alle_Artikeltypen',
    'annotationDelivery': 'Bemerkung zum Lieferschein',
    'annotationStock': 'Bemerkung zur Bestandsänderung',
    'selectArticleType': 'Artikeltyp auswählen',
    'editTransaction': 'Lieferschein bearbeiten',
    'deleteTransaction': 'Lieferschein löschen',
    'outgoing_transactions': 'Ausgehende_Lieferungen',
    'incoming_transactions': 'Eingehende_Lieferungen',
    'correction': 'Korrektur',
    'newCorrection': 'Neue Korrektur',

    'chooseTimeframe': 'Zeitraum wählen:',
    'allSalepoints': 'Alle Verkaufsstellen',
    'loadReport': 'Auswertung laden',

    'reset': 'Zurücksetzen',
    'manually': 'Manuell',
    'today': 'Heute',
    'days7': '7 Tage',
    'days14': '14 Tage',
    'days30': '30 Tage',
    'monthThis': 'Dieser Monat',
    'monthLast': 'Letzter Monat',
    'yearThis': 'Dieses Jahr',
    'all': 'Alle',

    'deliverySource': 'Lieferung von',
    'deliveryTarget': 'Lieferung an',
    'deliverySourceOrTarget': 'Lieferung von/an',
    'creationDate': 'Erstellungsdatum',
    'state': 'Status',
    'type': 'Art',
    'remark': 'Bemerkung',

    'view': 'Ansicht',
    'articleNumberDesigner': 'Artikelnr. Designer',
    'articleNumberFaex': 'Artikelnr. FAEX',
    'articleNumber': 'Artikelnummer',
    'articleType': 'Artikeltyp',
    'colour': 'Farbe',
    'size': 'Größe',
    'totalAmount': 'Gesamt',
    'externalAmount': 'Extern',
    'soldAmount': 'Verkauft',
    'storageAmount': 'Lager',
    'salePrice': 'Verkaufspreis',
    'price': 'Preis',
    'salePriceAbb': 'Vk-Preis',
    'purchasePrice': 'Einkaufspreis',
    'name': 'Name',
    'gender': 'Geschlecht',
    'sizeCategory': 'Größenkategorie',
    'description': 'Beschreibung',
    'sum': 'Summe',

    'external': 'Extern:',
    'sold': 'Verkauft:',
    'where': 'Wo',
    'howMany': 'Wieviele',
    'correctedOrReturned': 'Korrigiert/Zurückgeschickt',
    'correctedBy': 'Davon korrigiert',
    'correctionDate': 'Korrekturdatum',
    'yes': 'Ja',

    'salePoint': 'Verkaufsstelle',
    'saleDate': 'Verkaufsdatum',
    'articleName': 'Artikelname',
    'amount': 'Anzahl',
    'defaultSalePrice': 'Originalpreis',
    'paymentGross': 'Zahlung brutto an Designer (60%)',
    'paymentNet': 'Zahlung netto an Designer',
    'orderNumber': 'Bestellnummer',
    'orderState': 'Bestellstatus',
    'orderProcessingState': 'Bearbeitungstatus',

    'error': 'Interner Fehler!',
    'errorMessage': 'Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Administrator.',
    'errorImage': 'Das Format des Bildes ist nicht korrekt.',
    'errorCorrectionValues': 'Die korrigierten Werte dürfen keine negative Bilanz aufweisen',
    'errorEmptyValue': 'Mindestens ein Wert muss gesetzt sein.',
    'errorInvalidAmount1': 'Die zu verschickenden Artikel für ',
    'errorInvalidAmount2': 'stimmen nicht mit dem Bestand überein. Folgende Angaben sind falsch: ',
    'errorStocks': 'Der gesuchte Artikel konnte im Lager nicht gefunden werden.',

    'news': 'Neuigkeiten',
    'greeting_short': 'Hallo, ',
    'greeting_long': 'Hallo, Nutzer!',
    'nowNews': 'Momentan gibt es keine Neuigkeiten.',

    'addCorrection': 'Korrektur anlegen',
    'submitCorrection': 'Korrektur bestätigen',
    'submitCorrection2': 'Möchten Sie die Korrektur bestätigen?',
    'submitDelivery': 'Lieferung bestätigen',
    'submitDelivery2': 'Möchten Sie die Lieferung akzeptieren? \n Anschließend ist keine Korrektur mehr möglich.',
    'submitDelivery3': 'Möchten Sie den Lieferschein zwischenspeichern oder abschicken? Nach dem Abschicken kann er nicht mehr bearbeitet werden!',
    'submitDeliveryIncome': 'Liefereingang bestätigen',
    'submitDeliveryIncome2': 'Möchten Sie den Liefereingang akzeptieren?',
    'submitEditing': 'Bearbeitung bestätigen',
    'submitEditing2': 'Möchten Sie die Bearbeitung beginnen? Sie können Korrekturen hinzufügen.',
    'updateStock': 'Bestand Aktualisieren',
    'updateStock2': 'Möchten Sie den Bestand um die angegebenen Artikel verändern? Sie können die Bestandsveränderung zwischenspeichern oder abschicken. Nach dem Abschicken ist eine Änderung nicht mehr möglich.',

    'orderStateFiltering': '- Bestellstatus filtern -',
    'orderProgressStateFiltering' : '- Bearbeitungsstatus filtern -',
    'OrderRegistered': 'Bestellung aufgenommen',
    'OrderInProgress': 'Bestellung in Arbeit',
    'OrderCanNotBeDelivered': 'Ware kann nicht geliefert werden',
    'OrderArrivedFAEX': 'Ware ist bei FAEX angekommen',
    'OrderCanBeShipped': 'Ware kann an Kunden verschickt werden',
    'OrderShipped': 'Ware ist zum Kunden verschickt worden',
    'OrderWillBePickedUp': 'Ware wird vom Kunden abgeholt',
    'OrderWasPickedUpByCustomer': 'Ware wurde vom Kunden abgeholt',
    'OrderReturned': 'Ware kam zurück',
    'OrderCanceled': 'Bestellung ist storniert',
    'OrderPaymentWaitingForReturn': 'Kunde bekommt das Geld zurück',
    'OrderPaymentReturned': 'Kunde hat das Geld zurückbekommen',
    'OrderComplete': 'Bestellung abgeschlossen',
    'OrderAssumesReturnPolicy': 'Bestellung in Rückgaberecht',
    'OrderCompletedAndReadyForAccountBooks': 'Bestellung abgeschlossen und gebucht',
    'NA': 'NA',

    'Designer': 'Designer',
    'Boutique': 'Boutique',
    'FAEX': 'FAEX',

    'search...': 'Suche...',
    'filteringOptions': 'Filtermenü',
    'allOrderedArticles': 'Alle bestellte Artikel',
    'particularOrder': 'Alle Bestellpositionen in der Bestellung vom Kunde',
    'particularOrderClose': 'Schließen',
    'particularOrderPositionOpen': 'Bestellten Artikel öffnen',

    'manageOrder' : 'Bestellung bearbeiten',
    'label' : 'Label',
    'dateOfOrdering': 'Bestelldatum',
    'orderStatus': 'Bestellstatus',
    'prototype': 'Artikeltyp',
    'orderProcessingStatus': 'Bearbeitungsstatus',
    'unitPrice' : 'Einzelpreis',
    'prepayment': 'Anzahlung',
    'priceIncrement' : 'Preisänderung',
    'placeOfOrdering': 'Standort',
    'paymentTypeForPrepayment': 'Zahlungsart (Anzahlung)',
    'outstandingBalance': 'Noch offen',
    'paymentDueTo': 'Restzahlung Datum',
    'paymentMethodForBillDue': 'Zahlungsart (Restzahlung)',
    'deliveredViaAgend' : 'Versand an der Kundin durch',
    'customer' : 'Kunde',
    'billnumber' : 'Rechnungsnummber',
    'refundDate': 'Erstattung Datum',
    'orderedAtDesigner': 'Ware bei Designer bestellt',
    'deliveredToFAEX': 'Ware angekommen',
    'dispatchedToCustomer': 'Ware an Kunden verschickt',
    'dispatchedToBoutique' : 'Ware zu Boutique verschickt',
    'retouredByCustomer': 'Ware vom Kunden zurückgekommen',
    'pickedUpByCustomer': 'Ware vom Kunden abgeholt',
    'remarkPart1': 'Notizen',
    'remarkPart2': ' an ',
    'remarkPart3': 'am Designer',
    'remarkPart4': ' und ',
    'remarkPart5': ' von ',
}